module.exports = __webpack_public_path__ + "static/media/ProfDanWang.e799af06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/comp/sub1/ProfDanWang.jpg
// module id = 198
// module chunks = 0